import PropTypes from 'prop-types'
import { SIZE } from 'baseui/input'

import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import useDevTools from '@/containers/DevToolsNew/shared/useDevTools'

import { DateInputWrap, FiltersRow, SearchInputWrap, SelectWrap } from './styled-components'

const FeedbackFiltersBar = ({ filters, exportCsv }) => {
  const { t } = useDevTools()

  const feedbackTypeOptions = {
    all: t('feedback.filter_all'),
    upvote: t('feedback.filter_upvote'),
    downvote: t('feedback.filter_downvote'),
  }
  const versionOptions = {
    legacy: t('feedback.filter_version_legacy'),
    new: t('feedback.filter_version_new'),
  }

  return (
    <FiltersRow>
      <SearchInputWrap>
        <SDInput
          currentValue={filters.search}
          outerOnchange={filters.onSearchChange}
          type='search'
          size={SIZE.compact}
          placeholder={t('feedback.search_placeholder')}
          onKeyDown={event => {
            if (event.key === 'Enter') filters.onSearch()
          }}
        />
      </SearchInputWrap>

      <DateInputWrap>
        <SDInput
          currentValue={filters.start}
          outerOnchange={filters.onStartChange}
          type='date'
          size={SIZE.compact}
        />
      </DateInputWrap>

      <DateInputWrap>
        <SDInput
          currentValue={filters.end}
          outerOnchange={filters.onEndChange}
          type='date'
          size={SIZE.compact}
        />
      </DateInputWrap>

      <SelectWrap>
        <SDSelect
          optionsList={feedbackTypeOptions}
          selectedValue={filters.feedbackType}
          onChangeHandler={params => filters.onFeedbackTypeChange(params.option?.id)}
          placeholder={t('feedback.filter_all')}
        />
      </SelectWrap>

      <SelectWrap>
        <SDSelect
          optionsList={versionOptions}
          selectedValue={filters.version}
          onChangeHandler={params => filters.onVersionChange(params.option?.id)}
        />
      </SelectWrap>

      <SDButton size={SIZE.compact} block={false} isLoading={filters.isLoading} onClick={filters.onSearch}>
        {t('feedback.search_button')}
      </SDButton>

      <SDButton
        kind='secondary'
        size={SIZE.compact}
        block={false}
        isLoading={exportCsv.isExporting}
        onClick={exportCsv.onExportCsv}
      >
        {t('feedback.export_csv')}
      </SDButton>
    </FiltersRow>
  )
}

FeedbackFiltersBar.propTypes = {
  filters: PropTypes.shape({
    search: PropTypes.string.isRequired,
    start: PropTypes.string.isRequired,
    end: PropTypes.string.isRequired,
    feedbackType: PropTypes.string.isRequired,
    version: PropTypes.string.isRequired,
    isLoading: PropTypes.bool,
    onSearchChange: PropTypes.func.isRequired,
    onStartChange: PropTypes.func.isRequired,
    onEndChange: PropTypes.func.isRequired,
    onFeedbackTypeChange: PropTypes.func.isRequired,
    onVersionChange: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
  }).isRequired,

  exportCsv: PropTypes.shape({
    isExporting: PropTypes.bool,
    onExportCsv: PropTypes.func.isRequired,
  }).isRequired,
}

export default FeedbackFiltersBar
